import { DivergentStackedBarData } from "../../../../apis/MatchAPI"
import Link from "next/link"
import { LocalizedMatch } from "../../../../types/match"
import { statNumberToString } from "../../../../apis/transform/stats"
import * as ImageConstants from "../../../../constants/images"
import Image from "next/image"
import style from "./style.module.scss"
import { Row, Col } from "react-bootstrap"
import { Progress } from "antd"

export function DivergentStackedBar({
  match,
  teamHomeUrl,
  teamAwayUrl,
  data,
  showHeader,
}: {
  match: LocalizedMatch
  teamHomeUrl: string
  teamAwayUrl: string
  data: DivergentStackedBarData[]
  showHeader: boolean
}) {
  return (
    <ul className={style.divergentStackedBarContainer}>
      {showHeader && (
        <li className={style.comparisonListElement}>
          <div className={style.teams}>
            <div className={style.teamImage}>
              <Link href={teamHomeUrl} passHref>
                <a title={match.homeTeam?.name}>
                  <Image
                    src={match.homeTeam?.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                    alt={match.homeTeam?.name}
                    title={match.homeTeam?.name}
                    layout={"intrinsic"}
                    width={50}
                    height={50}
                  />
                </a>
              </Link>
            </div>
            <div className={style.teamImage}>
              <Link href={teamAwayUrl} passHref>
                <a title={match.awayTeam?.name}>
                  <Image
                    src={match.awayTeam?.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                    alt={match.awayTeam?.name}
                    title={match.awayTeam?.name}
                    layout={"intrinsic"}
                    width={50}
                    height={50}
                  />
                </a>
              </Link>
            </div>
          </div>
        </li>
      )}

      {data &&
        data.map((element) => {
          return (
            <li key={element.code} className={style.comparisonListElement + " " + style[element.code]}>
              <Row>
                <Col
                  xs={3}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  className={style.parameterValue + " " + style.parameterValueHome}
                >
                  {statNumberToString(element.homeOriginalValue, element.unitMeasurement)}
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.parameterName}>
                  {element.parameterName}
                </Col>
                <Col
                  xs={3}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  className={style.parameterValue + " " + style.parameterValueAway}
                >
                  {statNumberToString(element.awayOriginalValue, element.unitMeasurement)}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Progress percent={element.homePercentageValue} showInfo={false} strokeColor={"#ffc107"} />
                </Col>
              </Row>
            </li>
          )
        })}
    </ul>
    // <ul className="hs-comparison hs-comparison-team" style={{ padding: "1rem" }} id={"divergentMatch_" + match.id}>
    //   {showHeader && (
    //     <li className="hs-head hs-comparison--head">
    //       <div className="hs-home hs-comparison--head-home">
    //         <div className="team-image-none">
    //           <Link href={teamHomeUrl}>
    //             <a title={match.homeTeam?.name}>
    //               <Image
    //                 src={match.homeTeam?.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
    //                 alt={match.homeTeam?.name}
    //                 title={match.homeTeam?.name}
    //                 layout={"intrinsic"}
    //                 width={50}
    //                 height={50}
    //               />
    //             </a>
    //           </Link>
    //         </div>
    //       </div>
    //       <div className="hs-away hs-comparison--head-away">
    //         <div className="team-image-none">
    //           <Link href={teamAwayUrl}>
    //             <a title={match.awayTeam?.name}>
    //               <Image
    //                 src={match.awayTeam?.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
    //                 alt={match.awayTeam?.name}
    //                 title={match.awayTeam?.name}
    //                 layout={"intrinsic"}
    //                 width={50}
    //                 height={50}
    //               />
    //             </a>
    //           </Link>
    //         </div>
    //       </div>
    //     </li>
    //   )}
    //   {data &&
    //     data.map((element) => {
    //       return (
    //         <li
    //           key={element.code}
    //           className={
    //             "team_stats-balls_touched_percentage team_stats-balls_touched_percentage-format team_stats_" +
    //             element.code
    //           }
    //         >
    //           <div className="hs-name">{element.parameterName}</div>
    //           <div className="hs-value hs-value-home">
    //             {statNumberToString(element.homeOriginalValue, element.unitMeasurement)}
    //           </div>
    //           <svg className="hs-bar" preserveAspectRatio="none" viewBox="0 0 100 1">
    //             <rect className="hs-bar-empty" x="0" y="0" width="100" height="1" />
    //             <rect
    //               className="hs-bar-home"
    //               x="0"
    //               y="0"
    //               rx="0"
    //               ry="0"
    //               width={element.homePercentageValue}
    //               height="1"
    //             />
    //             <rect
    //               className="hs-bar-away"
    //               x={100 - element.awayPercentageValue}
    //               y="0"
    //               rx="0"
    //               ry="0"
    //               width={element.awayPercentageValue}
    //               height="1"
    //             />
    //           </svg>
    //           <div className="hs-value hs-value-away">
    //             {statNumberToString(element.awayOriginalValue, element.unitMeasurement)}
    //           </div>
    //         </li>
    //       )
    //     })}
    // </ul>
  )
}
